import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { Col } from "antd";
import { ConfirmationModal, confirmationModalConfigs } from "components/ActionModals/ConfirmationModal";
import { passwordReset } from "services";

export const PasswordResetButton = observer(() => {
  const { actionModals, userCard } = useStores();

  const passwordResetHandler = () => {
    actionModals.open(
      () => (
        <ConfirmationModal
          text="Подтвердите сброс пароля пользователя"
          successText="Новый пароль отправлен на почту"
          buttonText="Сбросить"
          calledQuery={() => passwordReset({ userId: userCard.card.id })}
          onSuccess={() => {
            setTimeout(() => userCard.fetchCardById(userCard.card.id), 1500);
          }}
        />
      ),
      {
        ...confirmationModalConfigs,
        title: "Сброс пароля",
        onClose: () => actionModals.closeAll(),
      }
    );
  };

  return (
    <Col>
      <CustomButton type="primary" onClick={passwordResetHandler}>
        Сбросить пароль
      </CustomButton>
    </Col>
  );
});
